import { isNil } from 'lodash';
import React, { useContext } from 'react';
import { View as RNView, StyleSheet } from 'react-native';
import { MBView } from '@shared/components/MBView';
import { MBTextOverlineBold } from '@shared/components/typography';
import { MBCardChatThread } from '@shared/scenes/chat/thread/containers/thread/card';
import { ColorThemeContext, Colors, grid } from '@shared/styles';
import { i18n } from '@shared/util/i18n';
import { useNavigationFocus } from '@shared/util/navigation';

interface Props {
  threadId: string;
  channelSlug: string;
  onThreadUpdated?: () => void;
  showHeader?: boolean;
}

export function ThreadContainer({
  threadId,
  channelSlug,
  onThreadUpdated,
  showHeader = true,
}: Props) {
  const colors = useContext(ColorThemeContext);
  const isFocused = useNavigationFocus();

  return (
    <MBView style={styles.container}>
      {showHeader && (
        <MBView style={styles.header}>
          <MBTextOverlineBold color={colors.input.label}>
            {i18n('card.blocks.chatThread.title')}
          </MBTextOverlineBold>
        </MBView>
      )}
      {!isNil(channelSlug) && (
        <RNView style={styles.thread}>
          <MBCardChatThread
            threadId={threadId}
            isFocused={isFocused}
            channelSlug={channelSlug}
            onThreadUpdated={onThreadUpdated}
          />
        </RNView>
      )}
    </MBView>
  );
}

const styles = StyleSheet.create({
  container: {
    paddingHorizontal: grid(1),
  },
  thread: {
    paddingTop: grid(1),
    paddingBottom: grid(2),
  },
  header: {
    marginHorizontal: grid(2),
    borderBottomWidth: 1,
    borderBottomColor: Colors.v2.gray10,
    paddingTop: grid(3),
    paddingBottom: grid(1),
  },
});
